import { render, staticRenderFns } from "./PatientMsg.vue?vue&type=template&id=28be7bca&scoped=true"
import script from "./PatientMsg.vue?vue&type=script&lang=js"
export * from "./PatientMsg.vue?vue&type=script&lang=js"
import style0 from "./PatientMsg.vue?vue&type=style&index=0&id=28be7bca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28be7bca",
  null
  
)

export default component.exports